import { useAuthStore } from '~/stores/authStore';

export const useAiApiHeaders = () => {
    const authStore = useAuthStore();
    const config = useRuntimeConfig();
    const baseUrl = (config.public.worksiteApiUrl as string) || '';

    const getHeaders = (): Record<string, string> => ({
        Authorization: authStore.usableToken ?? '',
        'X-Tenant-Id': authStore.tenant?.getId() ?? '',
        Accept: 'application/json',
    });

    return { getHeaders, baseUrl };
};
